import { ColumnAsset } from '../../../models/LessonComponentContent';
import ColumnItemEditor from './ColumnItemEditor';
import { ColumnProps } from './Column';
import React from 'react';
import { RgbaColor } from '../../../models/LessonComponentStyle';
import { cloneDeep } from 'lodash';
import styles from '../../../styles/Column.module.css';
import { useLessonEditContext } from '../../../models/LessonEditContext';

export default function ColumnEditor(props: ColumnProps) {
  const columns: ColumnAsset[] = props.component.content.column;

  const { handleSettingsChange } = useLessonEditContext();

  const handleText = (value: string, currentIndex: number) => {
    const copy = cloneDeep(props.component.content.column);
    copy[currentIndex].text = value;
    handleChange(copy);
  };

  const handleChange = (items: ColumnAsset[]) => {
    const copy = cloneDeep(props.component);
    copy.content.column = items;
    handleSettingsChange(copy);
  };

  const handleAssetSelect = (assetkey: string, currentIndex: number) => {
    const copy = cloneDeep(props.component.content.column);
    copy[currentIndex].assetkey = assetkey;
    handleChange(copy);
  };

  const handleBackgroundColor = (color: RgbaColor, currentIndex: number) => {
    const copy = cloneDeep(props.component.content.column);
    copy[currentIndex].backgroundColor = color;
    handleChange(copy);
  };

  return (
    <div className={styles.gridContainerEditor}>
      {columns?.map((column, index) => (
        <ColumnItemEditor
          key={index}
          column={column}
          componentKey={props.component.componentkey}
          position={props.component.settings?.textPosition}
          handleText={(value: string) => handleText(value, index)}
          handleAssetSelect={(assetkey) => handleAssetSelect(assetkey, index)}
          handleBackgroundColor={(color) => handleBackgroundColor(color, index)}
        />
      ))}
    </div>
  );
}
